import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Droplet } from 'lucide-react';
import { CtaButton } from './CtaButton';
const warningSigns = ['¿Sientes una pesadez en el lado derecho o tu abdomen está siempre inflamado aunque no comas mucho?', '¿Sientes que los zapatos te aprietan al final del día o te despiertas con la cara hinchada?', '¿Sientes pequeños calambres o hormigueo en las plantas de los pies por la noche?', '¿Te despiertas más cansado de lo que te acostaste y necesitas café tras café para aguantar el turno de trabajo?', '¿Has notado manchas oscuras que no se quitan en el cuello o las axilas?'];
export function Hook() {
  return <section className="py-20 bg-cream-light" data-id="element-82">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="prose prose-lg md:prose-xl prose-forest mx-auto text-gray-800" data-id="element-84">
          <p className="font-medium text-xl md:text-2xl text-forest-dark mb-6 text-center" data-id="element-85">
            ¿Te sientes "pesado" después del almuerzo? ¿Te asusta que cada vez
            que vas al médico la noticia es la misma:{' '}
            <span className="italic text-alert" data-id="element-86">
              "Su azúcar sigue subiendo"
            </span>
            ?
          </p>

          <div className="my-12 not-prose" data-id="element-87">
            <h3 className="text-2xl md:text-3xl font-bold text-forest-dark text-center mb-8 font-heading" data-id="element-88">
              ¿Reconoces estas señales de auxilio de tu cuerpo?
            </h3>

            <ul className="space-y-4 mb-10" data-id="element-89">
              {warningSigns.map((sign, index) => <li key={index} className="flex items-start bg-white p-5 rounded-xl shadow-sm border border-cream-dark" data-id="element-90">
                  <div className="bg-alert/10 p-2 rounded-lg mr-4 flex-shrink-0" data-id="element-91">
                    <AlertCircle className="w-5 h-5 text-alert" data-id="element-92" />
                  </div>
                  <p className="text-base md:text-lg text-gray-700 leading-relaxed m-0 italic" data-id="element-93">
                    {sign}
                  </p>
                </li>)}
            </ul>

            <div className="flex justify-center my-10 not-prose" data-id="element-94">
              <CtaButton data-id="element-95" />
            </div>

            <div className="bg-forest text-cream-light p-6 md:p-8 rounded-2xl border-l-4 border-gold flex items-start" data-id="element-96">
              <Droplet className="w-8 h-8 text-gold mr-4 flex-shrink-0 mt-1" data-id="element-97" />
              <p className="text-base md:text-lg leading-relaxed m-0" data-id="element-98">
                No solo el colesterol es el que debería preocuparte tanto, sino
                los <strong className="text-gold" data-id="element-99">triglicéridos</strong> y la{' '}
                <strong className="text-gold" data-id="element-100">insulina sin control</strong> en
                tu cuerpo.
              </p>
            </div>
          </div>

          <p className="mb-6" data-id="element-101">
            Sé lo que es sentir que tu cuerpo te está fallando en el país donde
            más necesitas estar sano para proveer a tu familia.
          </p>

          <p className="mb-10" data-id="element-102">Pero te han estado mintiendo...</p>

          <div className="relative bg-white p-8 md:p-10 rounded-2xl shadow-lg border-l-4 border-gold my-12" data-id="element-103">
            <div className="absolute -top-6 -left-6 text-6xl text-gold opacity-30 font-serif" data-id="element-104">
              "
            </div>
            <p className="text-2xl md:text-3xl font-bold text-forest text-center leading-snug relative z-10 m-0" data-id="element-105">
              El problema no es tu comida, es el orden en que te la comes.
            </p>
            <div className="absolute -bottom-10 -right-4 text-6xl text-gold opacity-30 font-serif rotate-180" data-id="element-106">
              "
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}